import React, { useEffect, useRef, useState } from "react";
import "../SboePage.css";

const UP = (v) => (typeof v === "string" ? v.toUpperCase() : "");

export default function EditarModal({ open, registro, onClose, onSalvar }) {
  const [form, setForm] = useState({ sub: "", sb: "" });
  const subRef = useRef(null);

  useEffect(() => {
    if (!open || !registro) return;
    setForm({ sub: registro.sub || "", sb: registro.sb || "" });
    const t = setTimeout(() => subRef.current?.focus(), 40);
    return () => clearTimeout(t);
  }, [open, registro]);

  if (!open) return null;

  function salvar() {
    const payload = {
      sub: UP(form.sub).trim(),
      sb: UP(form.sb).trim(),
    };
    if (!payload.sub || !payload.sb) {
      alert("Preencha SUB e SB.");
      return;
    }
    onSalvar(payload);
  }

  return (
    <div className="sboe-modal-overlay" onClick={onClose}>
      <div className="sboe-modal-card" onClick={(e) => e.stopPropagation()}>
        <div className="sboe-modal-head">
          <h2>Editar registro #{registro?.id}</h2>
        </div>

        <div className="sboe-modal-body">
          <div className="sboe-form-row">
            <label>SUB</label>
            <input
              ref={subRef}
              className="sboe-input"
              value={form.sub}
              onChange={(e) => setForm((f) => ({ ...f, sub: e.target.value }))}
            />
          </div>

          <div className="sboe-form-row">
            <label>SB</label>
            <input
              className="sboe-input"
              value={form.sb}
              onChange={(e) => setForm((f) => ({ ...f, sb: e.target.value }))}
            />
          </div>
        </div>

        <div className="sboe-modal-foot">
          <button className="sboe-btn" onClick={onClose}>
            Cancelar
          </button>
          <button className="sboe-btn sboe-btn-primary" onClick={salvar}>
            Salvar
          </button>
        </div>
      </div>
    </div>
  );
}
